import React, { Fragment } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { palletsByCountry } from 'utils/journey';

const enhance = compose(injectIntl);

const VehicleMaxPallets = React.memo(({ intl, country, max_pallets }) => {
  const t = intl.messages;
  const vehicle_pallet_type = palletsByCountry[country] || palletsByCountry.default;
  return (
    !!max_pallets && (
      <Fragment>
        {max_pallets} {t.pallet_types[`${vehicle_pallet_type}_abbr`]}
      </Fragment>
    )
  );
});

VehicleMaxPallets.propTypes = {
  intl: PropTypes.object.isRequired,
  country: PropTypes.string,
  max_pallets: PropTypes.number,
};

export default enhance(VehicleMaxPallets);
